import React, { useState, useRef } from 'react';

const Pension = () => {
    const [basicSalary, setBasicSalary] = useState('');
    const [monthlypension, setMonthlypension] = useState(null);
    const [july22, setJuly22] = useState(null);
    const [july23, setJuly23] = useState(null);
    const [july24, setJuly24] = useState(null);
    const [total, setTotal] = useState(null);
    const [error, setError] = useState('');

    const modalRef = useRef();

    const calculateSalaryIncrease = () => {
        const salary = parseFloat(basicSalary);
        if (isNaN(salary) || salary <= 0) {
            setError('Please enter a valid basic salary.');
            setMonthlypension(null);
            setJuly22(null);
            setJuly23(null);
            setJuly24(null);
            setTotal(null);
            return;
        }

        const july2022Calc = salary * 0.15;
        const result1 = july2022Calc + salary

        const july2023Calc = result1 * 0.175;
        const result2 = july2023Calc + result1

        const july2024Calc = result2 * 0.15;
        const result3 = july2024Calc + result2

        const lastestCalc = result3 * 0.07;


        const totalCalc = lastestCalc + july2022Calc + july2023Calc + july2024Calc;

        setMonthlypension(lastestCalc.toFixed(2));
        setJuly22(july2022Calc.toFixed(2));
        setJuly23(july2023Calc.toFixed(2));
        setJuly24(july2024Calc.toFixed(2));
        setTotal(totalCalc.toFixed(2));
        setError('');

        // Show the Bootstrap modal
        const modal = new window.bootstrap.Modal(modalRef.current);
        modal.show();
    };

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow animate__animated animate__fadeIn">
                        <div className="card-body">
                            <h2 className="text-center text-primary mb-4">Pension Employees Calculator</h2>

                            <div className="mb-3">
                                <h5 htmlFor="basicSalary" className="form-label fw-semibold">Monthly Pension on 1st month of Retirement:</h5>
                                <input
                                    type="number"
                                    id="basicSalary"
                                    className="form-control"
                                    value={basicSalary}
                                    onChange={(e) => setBasicSalary(e.target.value)}
                                    placeholder="Enter your Monthly Pension - Self"
                                />
                            </div>

                            <div className="d-grid gap-2">
                                <button className="btn btn-primary" onClick={calculateSalaryIncrease}>
                                    Calculate
                                </button>
                            </div>

                            {error && (
                                <div className="alert alert-danger mt-3" role="alert">
                                    {error}
                                </div>
                            )}

                            <footer className="text-center mt-4 text-muted">
                                Muhammad Uzair Ihsan
                            </footer>
                            <div className="text-center mt-2 text-danger Danger" style={{ fontSize: "0.9rem" }}>
                                <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                This Calculator is not official
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bootstrap Modal */}
            <div
                className="modal fade"
                tabIndex="-1"
                ref={modalRef}
                aria-labelledby="salaryModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title" id="salaryModalLabel">Pension Increase Result</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <p><i className="fas fa-percentage text-danger"></i> <strong> Pension Increase 2025 (7%) :</strong> <span className="text-danger">{monthlypension}</span></p>
                            <p><i className="fas fa-coins text-warning"></i> <strong> July 2022 Increase(15%):</strong> <span className="text-warning">{july22}</span></p>
                            <p><i className="fas fa-coins text-warning"></i> <strong> July 2023 Increase(17.5%):</strong> <span className="text-warning">{july23}</span></p>
                            <p><i className="fas fa-coins text-warning"></i> <strong> July 2024 Increase(15%):</strong> <span className="text-warning">{july24}</span></p>
                            <hr />
                            <p><strong>After All Increase % in 2022-23-24 & 25:  </strong> <span className="text-success">{total}</span></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pension;

